module.exports = __webpack_public_path__ + "img/activities-1.5a8cf33c.jpg";